// resources/js/src/services/api/types.ts
export type ApiResponse<T> = {
  success: boolean;
  data?: T;
  message?: string;
  errors?: Record<string, string>;
  meta?: unknown;
};

export class ApiError extends Error {
  constructor(
    public status: number,
    message: string,
    public errors?: Record<string, string>,
    public body?: unknown,   // ✅ جديد — بيحتفظ بالـ response body
  ) {
    super(message);
    this.name = "ApiError";
  }
}